<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">View Course</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="course-basic-details {{course.courseStatus.toLowerCase()}}">
          <div class="course-basic-detail-row">
            <div class="course-basic-detail-column w-10p">
              <img class="thumbnail" [src]="imageURL">
            </div>

            <div class="course-basic-detail-column w-65p">
              <label>Course Name</label>
              <span class="coursename">{{course.courseName}}</span>
            </div>

            <div class="course-basic-detail-column course-flags w-20p">
              <div class="review-form-fileds-status flex-end pr-10" [hidden]="course.courseType == ''">
                <span class="course-type-label" [ngClass]="gettingStartedClass">
                  <fa-icon [icon]="faFlag"></fa-icon> {{course.courseType}}
                </span>
              </div>
            <!-- </div>

            <div class="course-basic-detail-column"> -->
              <div class="review-form-fileds-status flex-end">
                <span class="reviewstatus-{{course.courseStatus.toLowerCase()}}">
                  {{course.courseStatus.toUpperCase()}}
                </span>
              </div>
            </div>
          </div>
          <div class="h-30"></div>

          <div class="course-basic-detail-row"  >
            <div class="course-basic-detail-column">
              <label>Course ID</label>
              <span>{{course.courseId}}</span>
            </div>

            <div class="course-basic-detail-column">
              <label>Course Created</label>
              <span>{{course.courseCreated}}</span>
            </div>

            <div class="course-basic-detail-column">
              <label>Language</label>
              <span>{{course.language}}</span>
            </div>

            <div class="course-basic-detail-column">
              <label>Course Tags</label>
              <span>
                <ul class="stacked-list">
                  @for (tag of course.tagList; track tag) {
                    <li>
                      {{ tag.tagName }}
                    </li>
                  }
                </ul>
              </span>
            </div>
            <div class="course-basic-detail-column">
              <label>Total Enrollment </label>
              <span>{{course.enrollment}}</span>
            </div>
            <div class="course-basic-detail-column w-20p">
            </div>

          </div>
        </div>
        <div class="h-30"></div>
        <div class="course-basic-detail-column">
          <span class="heading">Course Program/s</span>
          <span>
            <ul class="stacked-list">
              @for (program of course.coursePrograms; track program) {
                <li>
                  {{ program }}
                </li>
              }
            </ul>
          </span>
        </div>
        <div class="h-30"></div>
        <div class="course-basic-detail-column">
          <span class="heading">Course Description</span>
          <span [innerHTML]="course.courseDescription"></span>
        </div>
        <div class="h-30"></div>
        <div class="course-basic-detail-column">
          <span class="heading">Course Materials</span>
          <div class="tableContents">
            <ng-container #materialContainer *ngTemplateOutlet="materiallistTable; context: {data: coursematerial, headerVisible: true}"></ng-container>
            <ng-template #materiallistTable let-data="data" let-headerVisible="headerVisible">

              <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Name">Name</th>
                  <td mat-cell *matCellDef="let material">
                    <a href="/view-material/{{material.id}}" [hidden]="!isMaterialClickable">{{material.materialName}}</a>
                    <span [hidden]="isMaterialClickable">{{material.materialName}}</span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Course Id">ID</th>
                  <td mat-cell *matCellDef="let material">
                    {{material.materialId}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Program">Type</th>
                  <td mat-cell *matCellDef="let material">
                    {{material.type}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="lang">
                  <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by enrollment">Language</th>
                  <td mat-cell *matCellDef="let material">
                    {{material.language}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="roundedLeft" sortActionDescription="Sort by Status">Status <app-information-popup [information]="information"></app-information-popup></th>
                  <td mat-cell *matCellDef="let material">
                    <app-status-bubble [status]="material.status"></app-status-bubble>
                  </td>
                </ng-container>
                @if (headerVisible) {
                  <tr mat-header-row *matHeaderRowDef="materialcolumnsToDisplay" class="tableHeader"></tr>
                }
                <tr mat-row *matRowDef="let tags; columns: materialcolumnsToDisplay"></tr>
              </table>
            </ng-template>
          </div>
        </div>
        <div class="h-30"></div>

        <div class="course-basic-detail-column" [hidden]="course.replacementId===null">
          <span class="heading">Course Version Information</span>
          <div class="review-form-fileds">
            <span class="label">Replacement for Retired Course </span>
            <span class="answers">{{course.replacementCourseId}} &nbsp; <a [href]="'view-course/'+course.replacementId"><img src="assets/filelinkicon.svg" height="30px" width="30px"></a></span>

          </div>
        </div>

        <div class="form-buttons" [hidden]="!showeditbutton">
          <button class="submit-form-button" [hidden]="!course.isEditable" (click)="navigatetoEdit()">Edit Course</button>
          <button class="delete-button" [hidden]="!course.isDeletable" (click)="deleteCourse()">Delete Course</button>
        </div>

      </div>
    </form>
    <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
  </div>

</div>
@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}
<app-footer></app-footer>
